import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";
import "./styles/_index.scss";
import "./utils/function/sidebarToggle";
import { Breakpoints } from "react-device-breakpoints";
// for react-photo-view
import "react-photo-view/dist/react-photo-view.css";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";

i18n
  .use(initReactI18next)
  .use(detector)
  .use(backend)
  .init({
    supportedLngs: ["en", "ur"],
    // lng: document.querySelector("html").lang,
    fallbackLng: "en",
    detection: {
      order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
    },
    react: { useSuspense: false },
  });

const breakpoints = {
  isTablet: "(max-width: 767px)",
};
ReactDOM.render(
  <Provider store={store}>
    <Breakpoints {...breakpoints}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Breakpoints>
  </Provider>,
  document.getElementById("root")
);
reportWebVitals();
